// Define the CartNotification class
class CartNotification extends HTMLElement {
  constructor() {
    super(); // Call the HTMLElement constructor

    // Select necessary elements and set event listeners
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        this.close();
      });
    });
  }

  open() {
    // Add necessary classes and event listeners for opening the notification
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    // Remove classes and event listeners for closing the notification
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    // Render the contents of the notification based on parsed state
    this.cartItemKey = parsedState.key;
    const sectionsToRender = this.getSectionsToRender();
    
    sectionsToRender.forEach((section) => {
      if (section.selector !== undefined && section.selector !== 'undefined') {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    // Define sections to render
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];    
  }

  getSectionInnerHTML(html, selector) {
    // Get inner HTML of a section based on selector
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    // Handle body click event
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    // Set active element
    this.activeElement = element;
  }
}

// Define the custom element 'cart-notification'
customElements.define('cart-notification', CartNotification);
